import UserSettingsManager from '@/manager/UserSettingsManager';

export default {
    /**
     * Get this user settings boolean value.
     * The dependency order between managers and stores is currently backward on this.
     * Store helpers are placeholders for backward dependency order situations and will go away
     * when we correct it, refactoring the business logic out of the store.
     */
    isSubjectCascadeDisabled(): boolean {
        const subjectCascadeDisabled = UserSettingsManager.isSubjectCascadeDisabled();
        return subjectCascadeDisabled;
    },
};
